import React from 'react';
import { useTranslation } from 'react-i18next';

export default function PaginationControls({ currentPage, totalPages, onChangePage }) {
    const { t } = useTranslation();

    return (
        <div className="d-flex align-items-center text-white flex-shrink-0">
            <i className="fas fa-angle-left me-2" onClick={() => onChangePage(0)} style={{ cursor: 'pointer' }} />
            <span>{t('paginação.page')}: {currentPage} / {totalPages}</span>
            <i className="fas fa-angle-right ms-2" onClick={() => onChangePage(1)} style={{ cursor: 'pointer' }} />
        </div>
    );
}